import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};

export const CommentIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '20';
			default:
				return '20';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '20';
			default:
				return '20';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width={getWidth(size)} height={getHeight(size)} fill={color} viewBox="0 0 20 20">
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Icon-Archieve" transform="translate(-316.000000, -39.000000)" fill={color}>
						<path
							d="M318.0004,41 L318.0004,53 L322.0004,53 L322.0004,55 L324.6664,53 L334.0004,53 L334.0004,41 L318.0004,41 Z M320.0004,59 L320.0004,55 L318.0004,55 C316.8964,55 316.0004,54.103 316.0004,53 L316.0004,41 C316.0004,39.897 316.8964,39 318.0004,39 L334.0004,39 C335.1034,39 336.0004,39.897 336.0004,41 L336.0004,53 C336.0004,54.103 335.1034,55 334.0004,55 L325.3334,55 L320.0004,59 Z M320,46 L320,44 L332,44 L332,46 L320,46 Z M320,50 L320,48 L332,48 L332,50 L320,50 Z"
							id="ico-comments"
						></path>
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

CommentIcon.SIZE = SIZE;
CommentIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

CommentIcon.defaultProps = {
	color: '#ADAFB8',
};

export const StyledSpan = Styled.span`
	display: inline;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
